export default class FlowControl {
    constructor(cribbage, delayGame, delayTurn, autoShow) {
        this.cribbage = cribbage;
        this.lastAction = 0;
        this.timerGame = null;
        this.timerTurn = null;
        this.delayGame = delayGame || 1000;
        this.delayTurn = delayTurn || 0;
        this.delayShow = this.delayGame * 2;
        this.autoShow = true;
       
        this.maxTurnTimeouts = 3;
        this.turnTimeOuts = {
            player1: 0,
            player2: 0
        };

        this.gameAutoCommands = ["startround", "endCut", "confirmCrib", "go", "clear", "show", "xnext", "nextShow"];

        this.playerAutoCommands = ["playAllCribCards", "play", "nextRound"];

        this.ignoreActions = ["select", "chat", "invalidMove", "startPlayTimer"];

        this.onActionEventListener =  this.onAction.bind(this);
        //note: would be nice if it had no event listener, just invoked by the game and/or a last action timestampe to know when to take new action
        //////this.cribbage.event.addListener("onTurn", this.onTurn.bind(this));
        this.cribbage.event.addListener("actionEnded", this.onActionEventListener);
        this.cribbage.event.addListener("stateChange", this.onActionEventListener);
        //this.cribbage.event.addListener("action", this.onActionStart.bind(this));
    }
    getGameDelay() {
        var delayGame = this.delayGame;
        // var cribbage = this.cribbage;
        // if (cribbage) {
        //     let state = cribbage.currentState
        //     if (state === "showNonDealerHand" || state === "showDealerHand" || state === "showCrib") delayGame = delayGame * 2;
        // }
        return delayGame;
    }
    getTurnDelay() {
        var delayTurn = this.delayTurn;
        if (this.cribbage && this.cribbage.currentState === "crib") {
            delayTurn = delayTurn * 1.5;
        }
        if (this.cribbage && this.cribbage.currentState === "endRound") {
            delayTurn = delayTurn / 2;
        }
        if (this.cribbage && this.cribbage.currentState === "shuffle") {
            delayTurn = delayTurn / 3;
        }
        if (this.cribbage && this.cribbage.currentState === "shuffleCut") {
            delayTurn = delayTurn / 3;
        }
        return delayTurn;
    }
    resetTimeOuts() {
        this.turnTimeOuts = {
            player1: 0,
            player2: 0
        };
    }
    kickPlayer(player) {
        let cribbage = this.cribbage;
        if (!player) return false;
        if (!cribbage) return false;

        cribbage.action("quit", "Idle time out", player);
    }
    incrementTimedOut(player, actionTaken) {
        if (!player) return false;
        //don't count "nextRound" for now because it it new
        if (actionTaken === "nextRound") return false;
        if (this.cribbage.currentState === "shuffle") return false; //don't count shuffle
        if (this.cribbage.currentState === "shuffleCut") return false; //don't count shuffle

        let turnTimeOuts = this.turnTimeOuts[player] || 0;

        turnTimeOuts = turnTimeOuts + 1;
        this.turnTimeOuts[player] = turnTimeOuts;

        let cribbage = this.cribbage;
        if (cribbage) cribbage.logEvent("incrementTimedOut", turnTimeOuts, player);
    }
    isPlayerIdle(player) {
        if (!player) return false;

        let timeouts = this.turnTimeOuts[player];
        if (timeouts < this.maxTurnTimeouts) return false;

        return true;
    }
    destroy() {
        if (this.cribbage) {
            this.cribbage.event.removeListener("actionEnded", this.onActionEventListener);
            this.cribbage.event.removeListener("stateChange", this.onActionEventListener);
            // this.cribbage.event.removeListener("action", this.onActionStart.bind(this));
        }
        this.cribbage = null;
        clearTimeout(this.timerGame);
        clearTimeout(this.timerTurn);
    }

    onAction(arg) {
        this.startProcessEvent(arg);
    }

    startProcessEvent(arg) {
        if (!this.cribbage) return;
        let cribbage = this.cribbage;
        let delayTurn = this.getTurnDelay();
        let delayGame = this.getGameDelay(); //could be by action not by state
        let playerTurn = this.cribbage.playerTurn;
        let state = this.cribbage.currentState;

        //ignore some events so it does not reset the timer
        if (this.ignoreActions.indexOf(arg.command) != -1) return;

        let gameActions = this.getActions(this.gameAutoCommands);
        let hasGameActions = (gameActions.length !== 0) && Boolean(delayGame);

        //reset timer
        clearTimeout(this.timerGame);
        if (hasGameActions && delayGame !== 0) {
            this.timerGame = setTimeout(() => {
                this.doAction(this.gameAutoCommands);
            }, delayGame);
        }

        //reset idle timer
        if (state === "preGame" || state === "endMatch" || state === "idle" || state === "matching") {
            this.resetTimeOuts();
        }

        let playerActions = this.getActions(this.playerAutoCommands);
        let hasPlayerActions = (playerActions.length !== 0) && Boolean(delayTurn) && Boolean(playerTurn);

        //reset turn timer
        clearTimeout(this.timerTurn);
        if (hasPlayerActions && delayTurn !== 0) {
            cribbage.action("startPlayTimer", 0, "player1");
            cribbage.action("startPlayTimer", 0, "player2");
            cribbage.action("startPlayTimer", delayTurn, playerTurn);
            this.timerTurn = setTimeout(() => {
                let actionTaken = this.doAction(this.playerAutoCommands);
                if (actionTaken) {
                    this.incrementTimedOut(playerTurn, actionTaken);
                    if (this.isPlayerIdle(playerTurn)) {
                        this.kickPlayer(playerTurn);
                    }
                }
            }, delayTurn);
        }

    }

    getActions(autoCommands) {
        let actions = [];
        if (this.cribbage.playerTurn) {
            actions = this.cribbage.getActions(this.cribbage.playerTurn);
        }
        else {
            let actions1 = this.cribbage.getActions("player1");
            let actions2 = this.cribbage.getActions("player2");
            actions = actions1.concat(actions2);
        }

        //filter out command the computer should not use
        actions = actions.filter((action) => {
            var autoActionExist = autoCommands.includes(action.command);
            if (autoActionExist === true)
                return true;
            else
                return false;
        });
        return actions;
    }
    doAction(autoCommands) {
        if (!autoCommands) autoCommands = this.gameAutoCommands;
        if (!this.cribbage) return;
        if (!autoCommands) autoCommands = this.gameAutoCommands;
        let state = this.cribbage.currentState;
        let actions = this.getActions(autoCommands);
        if (actions.length > 0) {
            //random move
            let action = actions[Math.floor(Math.random() * actions.length)];
            // //save last action to detect auto action from human action
            // if (action.player) {
            //     this.lastAutoActions[action.player] = {
            //         command: action.command,
            //         value: action.value,
            //         player: action.player
            //     };
            // }
            this.cribbage.action(action.command, action.value, action.player);
            return action.command;
        }
        return false;
    }
}